import React from 'react';
import { connect } from 'react-redux';
import { Modal as BootstrapModal, ModalHeader, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import Loader from '../../../../shared/components/Loader/Loader.jsx';
import Modal from '../../../../shared/components//Modals/Modal.jsx';
import Phone from '../../Freelance/Component/Phone/Phone.jsx';
import Email from '../../Freelance/Component/Email/Email.jsx';
import MailingList from '../../Freelance/Component/MailingList/MailingList.jsx';
import {isAdmin} from '../../../../shared/services/userService.js';

import './ContactModal.scss';

class ContactModal extends Modal {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      errors: false
    };

    this.close = () => this.props.closeModal();
  }

  onCvDownloaded = () => {
    this.setState({loading: true});
    if(this.props.onCvNormaliseDownloaded) {
      this.props.onCvNormaliseDownloaded()
        .then(() => {
          this.setState({loading: false});
        })
        .catch((err) => {
          this.setState({loading: false});
        })
    } else {
      this.setState({loading: false});
    }
  };

  render() {
    const modalProps = {
      className: 'modal-email'
    };

    if (!this.state.loading) {
      modalProps.toggle = this.close;
    }

    const currentUser = this.props?.currentUser ?? null;
    const freelance = this.props.freelance;

    return (
      <BootstrapModal {...modalProps} isOpen={this.props.isOpen} size="lg">
        <Loader visible={!!this.state.loading}>Téléchargement du CV</Loader>
        <ModalHeader {...modalProps}>Contactez {this.props.user?.fullname ?? ''}<br /><small>(User id #{this.props.user?.id ?? ''} ; Freelance id #{this.props.freelance?.id ?? ''})</small></ModalHeader>
        <ModalBody>
          <div className="text-center mb-4">
            <div className="text">
              Le profil de <strong>{this.props.user?.fullname ?? ''}</strong> vous intéresse ? Contactez-nous afin que nous vous mettions en relation et validions ses disponibilités.
            </div>
            <div className="tel">
              <div className="label">Téléphone</div>
              <Phone user={this.props.user} />
            </div>
            <div className="email">
              <div className="label">E-mail</div>
              <Email user={this.props.user}/>
            </div>
            {this.props.isAdmin ?
              <div className="email">
                <div className="label">Envoyer un e-mail</div>
                <MailingList user={this.props.user} freelance={this.props.freelance} />
              </div>
              : ''
            }
            { currentUser &&
            <div className="cv">
              <div>Vous pouvez également, télécharger son CV</div>
              {this.props.isAdmin ?
                <div className="d-flex">
                  <div className="d-flex">
                    <button className="btn btn-primary" type="button" onClick={this.onCvDownloaded}>CV Normalisé</button>
                    &nbsp;
                    {freelance && freelance.cv && freelance.cv.original &&
                    <a href={freelance.cv.original} className="btn btn-primary">CV Original</a>
                    }
                  </div>
                  <div className={`errors d-flex p-2 ${this.state.errors ? '' : 'd-none'}`}>
                    {this.state.errors}
                  </div>
                </div>
                :
                <button className="btn btn-primary" type="button" onClick={this.onCvDownloaded}>Télécharger</button>
              }
            </div>
            }
          </div>
        </ModalBody>
      </BootstrapModal>
    );
  }
}

export default connect(
  state => ({
    currentUser: state.currentUser.user,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(withRouter(ContactModal));